module.exports = __webpack_public_path__ + "static/media/carousel-next.3207ae61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/carousel-next.svg
// module id = 2390
// module chunks = 0